import c from "react";
import p from "classnames";
import { GoogleAnalytics as d } from "../../../../../js/analytics/google/index.js";
import { useAuth as y } from "../../../auth/hooks/useAuth.js";
import n from "./landingButton.module.scss.js";
function A({
  children: e,
  primary: i,
  className: s,
  textColor: l = "#222",
  backgroundColor: f = "#ffffff",
  action: t,
  utmReferral: m
}) {
  const o = y() ?? null, u = async (r) => {
    if (t !== void 0) {
      if (typeof t == "string") {
        const a = await d.appendAnalyticsToUrl(t, m);
        return window.open(a.toString(), "_blank");
      }
      return t(
        {
          customer: o == null ? void 0 : o.customer
        },
        r
      );
    }
  };
  return /* @__PURE__ */ c.createElement(
    "button",
    {
      "data-testid": "landing-button",
      onClick: (r) => u(r),
      className: p({
        [n.btn]: !0,
        [n.btn__primary]: i
      }, s),
      style: {
        color: l,
        backgroundColor: f
      },
      type: "button"
    },
    e
  );
}
export {
  A as LandingButton
};
//# sourceMappingURL=LandingButton.js.map
